import { Routes } from '@angular/router';
import { authGuard, visitanteGuard, hubRoleGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    {
        // Tela de início única do Smart Kaizen: quem chega na raiz do Auth (inclusive depois do
        // login sem ?modulo=) vai para o Início (módulo 'comunicacao') pelo handoff de uso único.
        // O authGuard da rota de handoff manda para o login quem ainda não tem sessão.
        path: '',
        pathMatch: 'full',
        redirectTo: '/autenticacao/handoff?modulo=comunicacao',
    },
    {
        path: 'admin',
        loadComponent: () => import('./features/admin/ui/admin-dashboard/admin-dashboard').then(m => m.AdminDashboard),
        canActivate: [hubRoleGuard(['administrador'])],
    },
    {
        path: 'admin/usuarios',
        loadComponent: () => import('./features/admin/ui/usuarios-lista/usuarios-lista').then(m => m.UsuariosLista),
        canActivate: [hubRoleGuard(['administrador'])],
    },
    {
        path: 'admin/usuarios/:id',
        loadComponent: () => import('./features/admin/ui/usuario-detalhe/usuario-detalhe').then(m => m.UsuarioDetalhe),
        canActivate: [hubRoleGuard(['administrador'])],
    },
    {
        path: 'admin/modulos',
        loadComponent: () => import('./features/admin/ui/modulos-lista/modulos-lista').then(m => m.ModulosLista),
        canActivate: [hubRoleGuard(['administrador'])],
    },
    {
        path: 'admin/modulos/:id',
        loadComponent: () => import('./features/admin/ui/modulo-detalhe/modulo-detalhe').then(m => m.ModuloDetalhe),
        canActivate: [hubRoleGuard(['administrador'])],
    },
    {
        path: 'admin/logs',
        loadComponent: () => import('./features/admin/ui/logs-lista/logs-lista').then(m => m.LogsLista),
        canActivate: [hubRoleGuard(['administrador'])],
    },
    {
        path: 'autenticacao/login',
        loadComponent: () => import('./features/autenticacao/ui/login/login').then(m => m.Login),
        canActivate: [visitanteGuard],
    },
    {
        path: 'autenticacao/handoff',
        loadComponent: () => import('./features/autenticacao/ui/handoff-redirect/handoff-redirect').then(m => m.HandoffRedirect),
        canActivate: [authGuard],
    },
    {
        path: 'autenticacao/registro',
        loadComponent: () => import('./features/autenticacao/ui/registro/registro').then(m => m.Registro),
        canActivate: [visitanteGuard],
    },
    {
        path: 'autenticacao/confirmacao-email',
        loadComponent: () => import('./features/autenticacao/ui/confirmacao-email/confirmacao-email').then(m => m.ConfirmacaoEmail),
    },
    {
        path: 'autenticacao/recuperacao-senha',
        loadComponent: () => import('./features/autenticacao/ui/recuperacao-senha/recuperacao-senha').then(m => m.RecuperacaoSenha),
        canActivate: [visitanteGuard],
    },
    {
        path: 'autenticacao/atualizacao-senha',
        loadComponent: () => import('./features/autenticacao/ui/atualizacao-senha/atualizacao-senha').then(m => m.AtualizacaoSenha),
    },
    {
        path: 'nao-autorizado',
        loadComponent: () => import('./features/autenticacao/ui/nao-autorizado/nao-autorizado').then(m => m.NaoAutorizado),
    },
    {
        path: 'politicas/termos-de-uso',
        loadComponent: () => import('./features/politicas/ui/termos-de-uso/termos-de-uso').then(m => m.TermosDeUso),
    },
    {
        path: 'politicas/politica-de-privacidade',
        loadComponent: () => import('./features/politicas/ui/politica-privacidade/politica-privacidade').then(m => m.PoliticaPrivacidade),
    },
    {
        path: '**',
        redirectTo: '',
    },
];
